import { RawEventRow } from '@kentik/ui-shared/query/query.types';
import { Collection } from 'core/model/Collection';
import RawEventModel from './RawEventModel';

export default class RawEventCollection extends Collection<RawEventModel> {
  get model() {
    return RawEventModel;
  }

  replace(rows: RawEventRow[]) {
    this.reset({ hard: true });
    const withIds = rows.map((row, idx) => ({ ...row, id: String(idx) }));
    this.set(withIds);
  }
}
